import React, { useCallback, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import ExchangeAllocationPopUp from './exchangeAllocattionPopup';

const ApexChart = ({ exchangeAllocationGraph }) => {
  console.log("🚀 ~ ApexChart ~ exchangeAllocationGraph:", exchangeAllocationGraph)
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const series = React.useMemo(() => {
    if (!exchangeAllocationGraph?.serise) return [];
    return exchangeAllocationGraph.serise.map(value => Number(value) || 0);
  }, [exchangeAllocationGraph?.serise]);

  const labels = React.useMemo(() => {
    if (!exchangeAllocationGraph?.options) return [];
    return exchangeAllocationGraph.options.map(label => String(label || ''));
  }, [exchangeAllocationGraph?.options]);

  const handleClick = useCallback((event, chartContext, config) => {
    const seriesIndex = config.dataPointIndex;
    if (seriesIndex !== -1 && labels[seriesIndex] && series[seriesIndex] !== undefined) {
      setSelectedData({
        label: labels[seriesIndex],
        value: series[seriesIndex]
      });
      setShowPopUp(true);
    }
  }, [labels, series]);

  const handleClose = useCallback(() => {
    setShowPopUp(false);
    setSelectedData(null);
  }, []);

  const options = React.useMemo(() => ({
    chart: {
      type: 'donut',
      events: {
        dataPointSelection: handleClick
      }
    },
    colors: ['#1d3b6f', '#a4906b', '#4a4c55', '#63366e', '#a9333a', '#006b68', '#006394', '#6f7197', '#c3b59b', '#828189', '#bf8486', '#bf8486', '#769a98', '#6d94b5'],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false
          }
        }
      }
    },
    labels,
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(2)}%`, // Show percentage inside the chart
    },
    tooltip: {
      y: {
        formatter: (val, opts) => {
          if (!opts || !opts.w || !opts.w.globals) return val; // Prevent error

          const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
          const percentage = ((val / total) * 100).toFixed(2);
          return `${val} (${percentage}%)`;
        }
      },
      custom: function ({ series, seriesIndex, w }) {
        const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
        const percent = ((series[seriesIndex] / total) * 100).toFixed(2);
        const label = w.globals.labels[seriesIndex];
        const value = series[seriesIndex];
        const color = w.config.colors[seriesIndex]; // Get the color for the slice
        return `
          <div class="tooltip-custom" style="padding: 8px; background: ${color}; color: #fff; border-radius: 4px; font-size: 12px;">
            ${label} : ${value} (${percent}%)
          </div>
        `;
      }
    },
    legend: {
      position: 'right',
      verticalAlign: 'center',
      floating: false,
      fontSize: '12px',
      fontFamily: "Montserrat SemiBold",
      onItemHover: {
        highlightDataSeries: false
      }
    },
    responsive: [{
      breakpoint: 1180,
      options: {
        chart: {
          height: "400px"
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'bottom',
          verticalAlign: 'bottom',
          offsetY: 0,
          offsetX: 0,
          floating: false
        }
      }
    }]
  }), [labels, handleClick]);

  return (
    <div className="mt-3">
      <div id="chart" className="left-donut-chart">
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
        />
      </div>
      {console.log("selectedData", selectedData)}
      {showPopUp && selectedData && (
        <ExchangeAllocationPopUp
          data={selectedData}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

export default ApexChart;